/// JTF3-added-AB-22-05-12

'use strict'

jQuery(document).ready(function($) {
	if ($('.navigation__stickynav') !== null && $('.navigation__stickynav').length > 0) {
		if ($(window).width() > 768) {
			var stickyInitial = $('.navigation__stickynav .navigation__menu').offset().top;

			$(document).on('scroll', function() {
				if ($(document).scrollTop() >= stickyInitial) {
					$('.navigation__stickynav .navigation__menu').addClass('navigation__menu--sticky');
					$('.navigation__stickynav').addClass('navigation__stickynav--locked');
					$('body').addClass('navigation__locked');
				} else {
					$('.navigation__menu--sticky').removeClass('navigation__menu--sticky');
					$('.navigation__stickynav--locked').removeClass('navigation__stickynav--locked');
					$('body').removeClass('navigation__locked');
				}
			})
		}
	}
});
